import type { DateValue } from '@internationalized/date';
import dayjs from 'dayjs';

// $saga impossible, weird compilation bug?
import { selectedPrice } from '../../store';
import { MinPriceDays } from '../../VisibleDates/types';

export const updateAside = (
    date: DateValue | undefined,
    minPricePerDays: MinPriceDays,
) => {
    if (date) {
        const selected =
            minPricePerDays[dayjs(date.toString()).format('YYYY-MM-DD')];
        if (selected) {
            selectedPrice.set({
                originalPrice: selected.originalAmount
                    ? selected.originalAmount / 100
                    : null,
                rebateAmount: selected.rebateAmount
                    ? `-${selected.rebateAmount / 100}€`
                    : null,
                actualPrice: selected.amount / 100,
                // date: dayjs(selected.date1.date).format('YYYY-MM-DD'),
            });
        }
    }
};
